import React from 'react'
import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Foundations'

export const EventInfo: React.FC<{ eventInfo: string; icon?: React.ReactNode }> = ({
  eventInfo,
  icon,
}) => {
  return (
    <WrapperStyled>
      {icon && <span className='event-info__icon'>{icon}</span>}

      <div>
        <span>{eventInfo}</span>
      </div>
    </WrapperStyled>
  )
}

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: spacing.smx1,

  '> .event-info__icon': {
    flexShrink: 0,
  },

  '> div:last-of-type': {
    flex: 1,
    boxSizing: 'border-box',
    display: 'inline-flex',
    alignItems: 'center',
    gap: spacing.smx2,
    height: '2rem',
    minWidth: 0,
    maxWidth: 'fit-content',
    margin: 0,
    padding: 0,
    fontSize: '1.4rem',
    fontWeight: 'bold',
    lineHeight: '2rem',
    whiteSpace: 'nowrap',

    '> span': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      wordWrap: 'normal',
    },
  },
})
